/**
 * Business
 * */

export interface IBusiness {
  _id: string
  code: string
  name: string
  description: string
  tasks: [{ [key: string]: string }]
  createdAt: Date
  updatedAt: Date
}

export const initAddBusiness = {
  name: '',
  tasks: null as null | string[],
  description: ''
}

export const initEditBusiness = {
  name: '',
  tasks: null as null | string[],
  description: ''
}

export const rulesAddBusiness = {
  'businessModule.name': 'required',
  taskList: 'required'
}

export const rulesEditBusiness = {
  'businessModule.name': 'required',
  taskList: 'required'
}

/**
 * Task
 * */

export interface ICompletionTime {
  id: string | number
  name: string
  averageTime?: number | string | null
  minimumTime?: number | string | null
  minimumTimeChanged?: boolean
}

export interface ITask {
  _id?: string
  name: string
  type: string,
  taskType: string
  description: string
  canSplitWay: boolean
  requireContainerNumber: boolean
  documentRequired: boolean
  taskStartEndDurationRequired: boolean
  allowCustomerViewDocument: boolean
  timeConditions: {
    name: string
    type: string
    timeType: string
  }[]
  completionTimes: {
    [key: string]: ICompletionTime[]
  }
  completionTimeCategories: number[]
}

export const initAddTask = {
  name: '',
  type: '',
  description: '',
  taskType: 'AFFECT_SHIPPING_TIME',
  canSplitWay: false,
  requireContainerNumber: false,
  documentRequired: false,
  taskStartEndDurationRequired: false,
  allowCustomerViewDocument: false,
  timeConditions: [
    {
      name: '',
      type: '',
      timeType: ''
    }
  ],
  completionTimes: {
    vehicleCategory: [
      {
        id: '',
        name: '',
        averageTime: null,
        minimumTime: null,
        minimumTimeChanged: false
      }
    ],
    contCategory: [
      {
        id: '',
        name: '',
        averageTime: null,
        minimumTime: null,
        minimumTimeChanged: false
      }
    ]
  },
  completionTimeCategories: [0, 1]
} as ITask

export const initEditTask = {
  name: '',
  type: '',
  description: '',
  taskType: 'AFFECT_SHIPPING_TIME',
  canSplitWay: false,
  requireContainerNumber: false,
  documentRequired: false,
  taskStartEndDurationRequired: false,
  allowCustomerViewDocument: false,
  timeConditions: [
    {
      name: '',
      type: '',
      timeType: ''
    }
  ],
  completionTimes: {
    vehicleCategory: [
      {
        id: '',
        name: '',
        averageTime: null,
        minimumTime: null
      }
    ],
    contCategory: [
      {
        id: '',
        name: '',
        averageTime: null,
        minimumTime: null
      }
    ]
  },
  completionTimeCategories: []
} as ITask
